import { Component, Input, OnInit } from '@angular/core';
import { EthWalletService } from 'src/app/services/eth-wallet.service';

@Component({
  selector: 'app-funds',
  templateUrl: './funds.component.html',
  styleUrls: ['./funds.component.scss']
})
export class FundsComponent implements OnInit {
  @Input() records: any[] = [];
  @Input() showAccount = false;

  constructor(public ethWalletService: EthWalletService) {}

  ngOnInit(): void {
  }

}
